<ion-header class="ion-no-border">
  <ion-item lines="full">
    <ion-label>
      <h6 class="bold">Chat</h6>
    </ion-label>

    <ion-button
      *ngIf="(role$ | async) >= roleLimits.CHAT_GROUP_CREATE"
      (click)="openNewChatGroupMenu($event)"
      tooltip="Add Chat Group">
      <ion-icon src="/assets/icons/24px/new-chat.svg" slot="icon-only"> </ion-icon>
    </ion-button>

    <ion-button (click)="closeSidebar.emit()" tooltip="Close" aria-label="Close">
      <ion-icon src="/assets/icons/24px/close.svg" slot="icon-only"> </ion-icon>
    </ion-button>
  </ion-item>
</ion-header>

<ion-content *ngIf="(showSettings$ | async)?.enableChat || (showSettings$ | async)?.enableChat === undefined">
  <ion-list *ngIf="(role$ | async) >= roleLimits.CHAT_GROUP_READ">
    <ion-item
      *ngFor="let chatGroup of chatGroups; trackBy: trackByChatGroup; last as last"
      (click)="select(chatGroup)"
      [lines]="last ? 'none' : 'inset'"
      [class.unread]="chatGroup.unread">
      <ion-fab-button tabindex="-1" *ngIf="chatGroup.name" class="bold {{ chatGroup.color }}" size="small">
        {{ chatGroup.name.charAt(0) }}
      </ion-fab-button>

      <!-- <ion-badge *ngIf="chatGroup.messages && chatGroup.messages.length > 0">
        {{ chatGroup.messages.length }}
      </ion-badge> -->

      <ion-label>
        {{ chatGroup.name }}
      </ion-label>

      <ion-icon *ngIf="chatGroup.unread" src="/assets/icons/24px/record.svg" class="unread-icon"> </ion-icon>

      <ion-button>
        <ion-icon src="/assets/icons/24px/chevron-right.svg" slot="icon-only"> </ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
<ion-content *ngIf="!(showSettings$ | async)?.enableChat && (showSettings$ | async)?.enableChat !== undefined">
      <ion-label class="chat-disabled">
        Chat Groups have been <strong>Disabled</strong> for this Session.
      </ion-label>
      <p class="chat-disabled">
        You can enable Chat Groups in the <strong>Advanced Show Settings</strong>. Please contact your Show Manager to enable Chat Groups.
      </p>
</ion-content>
